module.exports = "/_next/static/images/video_id_7140326784838470958-df46ae84408e2fde74cda0327feb052a.jpg";